export enum MatchingEntityResultCode {
    ACTIVE_EMPLOYMENT_ON_EXTERNAL_ORGANIZATION = 'ACTIVE_EMPLOYMENT_ON_EXTERNAL_ORGANIZATION',
    ACTIVE_EMPLOYMENT_ON_SAME_ORGANIZATION = 'ACTIVE_EMPLOYMENT_ON_SAME_ORGANIZATION',
    NAME_GENDER_MATCH = 'NAME_GENDER_MATCH',
    NO_MATCH_FOUND = 'NO_MATCH_FOUND',
    PENDING_REQUEST_ON_EXTERNAL_ORGANIZATION = 'PENDING_REQUEST_ON_EXTERNAL_ORGANIZATION',
    PENDING_REQUEST_ON_SAME_ORGANIZATION = 'PENDING_REQUEST_ON_SAME_ORGANIZATION',
}
